export function isSafari() {
    // https://stackoverflow.com/questions/7944460/detect-safari-browser
    if (typeof window !== 'undefined') {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
    return false;
};